import React, { useContext } from "react";
import { LoginContext } from "../../../lib/context";

const LoggedIn = () => {
  const { login, setLogin } = useContext(LoginContext);

  return (
    <>
      <div className="w-[51px] h-[51px] rounded-full flex justify-center items-center text-4xl bg-pinkColor text-white">
        N
      </div>

      <p className="text-center">
        You're logged in as <br /> youremail@gmail.com
      </p>
      <p className="text-center">No currently active plans.</p>

      <div className="flex flex-col items-center justify-center gap-y-5 w-48">
        <button
          type="button"
          class="text-pinkColor hover:text-white border-2 border-pinkColor hover:bg-pinkColor focus:ring-4 focus:outline-none focus:ring-red-300 font-semibold rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 uppercase w-full"
        >
          export collection
        </button>
        <button
          onClick={() => setLogin(null)}
          type="button"
          class="text-pinkColor hover:text-white border-2 border-pinkColor hover:bg-pinkColor focus:ring-4 focus:outline-none focus:ring-red-300 font-semibold rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900 uppercase w-full"
        >
          logout
        </button>
      </div>
    </>
  );
};

export default LoggedIn;
